import { render, staticRenderFns } from "./DiscountsTable.vue?vue&type=template&id=03c7d5d1&"
import script from "./DiscountsTable.vue?vue&type=script&lang=js&"
export * from "./DiscountsTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports